<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Hauler"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedHaulers"
      :columns="columns"
      :total-rows="totalHaulers"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'HaulerTable',
  components: {
    BaseTable
  },
  data() {
    return {
      haulers: [],
      totalHaulers: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'city', align: 'left', label: 'City', field: 'city', sortable: true },
        { name: 'state', align: 'left', label: 'State', field: 'state', sortable: true },
        { name: 'office_phone', align: 'left', label: 'Office Phone', field: 'office_phone', sortable: true },
        { name: 'contact_person', align: 'left', label: 'Contact Person', field: 'contact_person', sortable: true },
        { name: 'email', align: 'left', label: 'Email', field: 'email', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedHaulers() {
      return this.haulers.map(hauler => ({
        ...hauler,
        add_date: new Date(hauler.add_date).toLocaleDateString(),
        edit_date: new Date(hauler.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchHaulers();
  },
  methods: {
    fetchHaulers() {
      axios
        .get('/api/v1/hauler/haulers/')
        .then(response => {
          this.haulers = response.data;
          this.totalHaulers = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching haulers:', error);
        });
    },
    onAdd() {
      this.$router.push('/hauler/add');
    },
    getEditUrl(row) {
      return `/hauler/edit/${row.id}`;
    }
  },
  watch: {
    haulers() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the HaulerTable here */
</style>
